module.exports = __webpack_public_path__ + "static/img/bg_bg.a509cc4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg_bg.png
// module id = r7Ko
// module chunks = 94